import React from 'react'

function Reactt() {
  return <div>React</div>
}

export default Reactt
